import { faFaceFrownOpen } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CopyButton from "../utilities/CopyBtn";
import LoadingSpinner from "../utilities/LoadingSpinner";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { ToastContainer, toast } from "react-toastify";
import "../../styles/ReactToastify.css";

export default function OrderHistory({ user, userInfo }) {
  const { promiseInProgress } = usePromiseTracker();
  const [orders, setOrders] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [refreshOrders, setRefreshOrders] = useState();
  const [noOrders, setNoOrders] = useState("");
  const [orderToCancel, setOrderToCancel] = useState();
  // const [returnOrderData, setReturnOrderData] = useState({
  //   orderId: "",
  //   reason: "",
  // });

  // fetching orders from db
  useEffect(() => {
    // console.log(userInfo);
    if (userInfo?.orderHistory?.length !== 0) {
      console.log("Running Orders");
      console.log("orderHistory -- ", userInfo.orderHistory);
      trackPromise(
        axios
          .post(
            `${process.env.REACT_APP_BACKEND_LINK}/getorders`,
            userInfo.orderHistory
          )
          .then((response) => {
            // console.log("orderHistory", response);
            if (response.data === "No Orders") {
              // console.log(response.data);
              setNoOrders(response.data);
            } else {
              setNoOrders("");
              setOrders(response.data.reverse());
            }
          })
          .catch((err) => console.log(err))
      );
    }
  }, [userInfo, refreshOrders]);

  useEffect(() => {
    if (orders.length > 0) {
      orders.map((order) => {
        let updatedOrder = {};
        let awbCode;
        // Checking for AWB
        const awb = order.shiprocketDetails?.awb;
        // console.log(order.shiprocketDetails.awb);
        if (
          order.shiprocketDetails?.awb === false ||
          order.shiprocketDetails?.awb === "false" ||
          (awb && Object.keys(awb).length < 1)
        ) {
          console.log("Generate Awb");
          // Check if AWB already generated
          // if not generate awb
          // store in mongodb
          const id = order._id;
          const orderId = order.shiprocketDetails.order.srOrderId;
          const shipmentId = order.shiprocketDetails.order.shipmentId;
          trackPromise(
            axios
              .post(`${process.env.REACT_APP_BACKEND_LINK}/generateawb`, {
                id,
                orderId,
                shipmentId,
              })
              .then((res) => {
                // console.log("Generated AWB", res.data);
                awbCode = res.data.awb_code;
                const updatedOrder = {
                  ...order,
                  shiprocketDetails: {
                    ...order.shiprocketDetails.order,
                    awb: res.data,
                  },
                };
                // console.log("updatedOrder", updatedOrder);
              })
              .catch((err) => console.log(err))
          );
        } else {
          // console.log("Already generated");
          updatedOrder = order;
          awbCode = order?.shiprocketDetails?.awb?.awb_code;
        }

        // Tracking the shipment if status != delivered
        if (order.status !== "Delivered") {
          const currentStatus = order.status;
          const id = order._id;
          trackPromise(
            axios
              .post(`${process.env.REACT_APP_BACKEND_LINK}/trackorderstatus`, {
                id,
                awbCode,
                currentStatus,
              })
              .then((res) => {
                // console.log(res);
                if (res.data.track_status === 0) {
                  return updatedOrder;
                } else {
                  updatedOrder = {
                    ...updatedOrder,
                    status: res.data.activity_status,
                  };
                  return updatedOrder;
                }
              })
              .catch((err) => console.log(err))
          );
        }
      });
    }
  }, [orders]);

  const handleCancelOrder = (order) => {
    setOrderToCancel(order);
    setShowPopup(true);
  };

  const handleConfirmCancel = () => {
    // Perform cancel order logic here
    if (orderToCancel) {
      // console.log(orderToCancel);
      setShowPopup(false);

      const srOrderId = orderToCancel.shiprocketDetails?.order?.srOrderId;
      const awb_code = orderToCancel.shiprocketDetails?.awb?.awb_code;
      const id = orderToCancel._id;

      trackPromise(
        axios
          .post(`${process.env.REACT_APP_BACKEND_LINK}/cancelorder`, {
            srOrderId,
            awb_code,
            id,
          })
          .then((res) => {
            // console.log("res", res);
            setRefreshOrders(true);
            setOrderToCancel(null);
            // show message popup that order cancelled
            toast.success(res.data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .catch((err) => {
            console.log("err", err);
            toast.error(err.response.data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
      );
    }
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setOrderToCancel(null);
  };

  return (
    <div className="md:mx-40">
      {promiseInProgress === true && (
        <div className="md:-mx-40 absolute flex justify-center pt-60 h-full w-full bg-white bg-opacity-90">
          <LoadingSpinner />
        </div>
      )}
      <div className="md:mx-32">
        <h1 className="text-2xl md:text-3xl font-semibold mt-10 md:mt-20 mb-2">
          Hey, {userInfo.firstName}
        </h1>
        <hr />
        <div className="flex">
          <div className="md:w-1/5 border-r-2"></div>
          <div className="md:w-4/5 p-4 overflow-y-scroll h-[600px]">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold">All orders</h2>
              <a
                href="https://ambhos.shiprocket.co/tracking"
                target="_blank"
                rel="noopener noreferrer"
                className="mr-5 underline text-ambhosOrange font-semibold cursor-pointer active:scale-95"
              >
                Track Order
              </a>
            </div>

            {noOrders && (
              <div className="flex justify-center items-center h-96 text-2xl">
                <FontAwesomeIcon icon={faFaceFrownOpen} />
                <p className="ml-2 font-bold">{noOrders}</p>
              </div>
            )}

            {/* Orders */}
            {orders.map((order) => {
              const date = new Date(order.createdAt);
              date.setDate(date.getDate() + 7);
              const returnDate = date.toISOString();

              const newDate = new Date();
              newDate.setDate(newDate.getDate());
              const currentDate = newDate.toISOString();

              console.log(returnDate, " --- ", currentDate);
              console.log(returnDate > currentDate);

              const options = {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              };

              const formattedDate = date
                .toLocaleString("en-US", options)
                .replace(",", "");
              return (
                <div
                  key={order._id}
                  className="bg-white shadow-lg rounded-lg p-6 m-5"
                >
                  <div className="flex flex-col md:flex-row md:items-center justify-between mb-3 pb-2 border-b border-gray-200">
                    <div className="mb-4 md:mb-0">
                      <h2 className="text-base md:text-xl text-ambhosOrange font-semibold">
                        OrderId:{" "}
                        <span className="text-gray-700">{order.orderId}</span>
                        <CopyButton text={order.orderId} />
                      </h2>
                      <p className="text-sm">
                        <span className="font-semibold">Payment ref:</span>{" "}
                        {order?.paymentDetails?.razorpay_payment_id}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-700 font-semibold">
                        <span className="text-ambhosOrange">Status:</span>{" "}
                        {order.status}
                      </p>
                      {order?.shiprocketDetails?.awb?.awb_code && (
                        <p className="text-sm">
                          <span className="font-semibold">AWB:</span>{" "}
                          {order?.shiprocketDetails?.awb.awb_code}
                          <CopyButton
                            text={order?.shiprocketDetails?.awb.awb_code}
                          />
                        </p>
                      )}
                    </div>
                  </div>
                  {/* Add ordered color and size */}
                  {order.products.map((product) => {
                    return (
                      <div className="mb-4" key={product.id?._id}>
                        <div className="flex items-center justify-between py-2">
                          <div className="flex space-x-3">
                            <img
                              src={product.id?.images[0]}
                              alt={product.id?.productName}
                              className="h-8 w-8 object-contain"
                            />
                            <span className="w-32 md:w-64 lg:w-96 text-sm font-semibold">
                              {product.id?.brandName +
                                " " +
                                product.id?.productName}
                              {product.id?.color &&
                                " (" + product.id?.color + ") "}
                              {product?.selectedSize &&
                                "(Size: " + product?.selectedSize + ")"}
                            </span>
                          </div>
                          <span className="text-sm md:text-[15px]">
                            {product?.quantity} x ₹{product?.price.toFixed(2)}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                  <div className="flex flex-col md:flex-row justify-between text-sm md:text-base">
                    <div>
                      <span className="text-gray-500">Order Date:</span>
                      <span className="font-semibold"> {formattedDate}</span>
                    </div>
                    <div>
                      <span className="text-gray-500">Total:</span>
                      <span className="font-semibold">
                        {" "}
                        ₹{order.totalAmount}
                      </span>
                    </div>
                  </div>
                  {order.status !== "Cancelled" && (
                    <div className="mt-6 flex justify-around">
                      {returnDate > currentDate && (
                        <a
                          href="https://ambhos.shiprocket.co/tracking"
                          rel="noopener noreferrer"
                          target="_blank"
                          className="text-ambhosOrange"
                        >
                          Return
                        </a>
                      )}
                      {returnDate > currentDate &&
                        order.status !== "Delivered" && (
                          <p className="text-gray-300">|</p>
                        )}
                      {order.status !== "Delivered" && (
                        <>
                          <button
                            className="text-ambhosOrange"
                            onClick={() => handleCancelOrder(order)}
                          >
                            Cancel Order
                          </button>
                          {showPopup && (
                            <CancelOrderPopup
                              onCancel={handleConfirmCancel}
                              onClose={handleClosePopup}
                            />
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

const CancelOrderPopup = ({ onCancel, onClose }) => {
  const handleCancel = () => {
    onCancel();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-10">
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-10 md:rounded-xl"></div>
      <div className="bg-white rounded p-6 z-20">
        <h3 className="text-lg font-semibold mb-4">
          Confirm Order Cancellation
        </h3>
        <p className="mb-4">Are you sure you want to cancel the order?</p>
        <div className="flex justify-end">
          <button
            className="px-4 py-2 bg-red-500 text-white rounded mr-2"
            onClick={handleCancel}
          >
            Cancel Order
          </button>
          <button
            className="px-4 py-2 bg-gray-500 text-white rounded"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
